<template>
	<div class="news-list">
		<CFullEmpty v-if="tabData.length == 0" class="empty-box" />
		<template v-else>
			<div v-for="(item, index) in tabData" :key="index" class="news-item" @click="() => handleNews(item)">
				<div class="news-item-content">
					<p class="news-title van-multi-ellipsis--l2">
						{{ item.title }}
					</p>
					<p class="news-summary van-ellipsis">{{ item.newsAbstract }}</p>
					<p class="news-time font-Regular">{{ item.time | formatterTime }}</p>
				</div>
				<van-image class="news-item-image" fit="cover" :src="item.image"></van-image>
			</div>
		</template>
		<CFooterLoad ref="footerLoadObs" :more="hasMore" @load-more="loadMoreData" />
	</div>
</template>

<script>
import { Image as VanImage } from 'vant';
import { irstore } from '@/fetch/interface';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import CFooterLoad from '@/view/enterprise/components/c-footer-load.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import paginationMixin from '@/view/enterprise/mixins/paginationMixin';
import moment from 'moment';
import { getLanguageType } from '@/assets/js/i18n';

export default {
	components: {
		CFooterLoad,
		CFullEmpty,
		VanImage
	},
	mixins: [paginationMixin],
	props: {
		storeData: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	filters: {
		formatterTime(timestamp) {
			if (typeof timestamp !== 'number') {
				return '-';
			}
			return moment(timestamp).format('YYYY-MM-DD');
		}
	},
	data() {
		return {};
	},
	computed: {
		getCoverClass() {
			const type = this.moduleCoverType || 43;
			const coverMap = {
				43: 'cover--43',
				169: 'cover--169',
				21: 'cover--21'
			};
			return coverMap[type];
		}
	},
	mounted() {
		// install mixins
		this.PAGINATION_LOAD = this.loadModule;
		this.PAGINATION_OBS_INSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.install();
		};
		this.PAGINATION_OBS_UNINSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.uninstall();
		};
	},
	methods: {
		loadMoreData() {
			this.PAGINATION_LOAD_MORE();
		},
		refreshModule(query) {
			this.PAGINATION_REFRESH(query);
		},
		loadModule() {
			const { id } = this.storeData;
			return this.$axios
				.get(irstore.getNewsList(id), {
					moduleId: this.moduleId,
					pageStart: this.pageStart,
					pageNum: 20,
					languageType: getLanguageType()
				})
				.then(res => {
					const { data, extra } = res;

					const result = data || [];
					this.PAGINATION_DATA_UPDATE(result);
					this.$emit('refresh');

					const hasMore = extra.hasMore;
					return Promise.resolve(hasMore);
				})
				.catch(() => Promise.resolve(false));
		},
		handleNews(item) {
			this.viewModule('news', item);
		}
	},
	setup() {
		const { viewModule } = useModuleNavigation();
		return {
			viewModule
		};
	}
};
</script>

<style lang="less" scoped>
.empty-box {
	padding: 0.2rem 0;
}
.news-list {
	background: #f7f7f7;

	.news-item {
		height: 1.15rem;
		background: #ffffff;
		padding: 0.16rem 0.14rem;

		& + .news-item {
			margin-top: 0.08rem;
		}
		&-content {
			float: left;
			width: 2.24rem;
			position: relative;
			height: 100%;
			.news {
				&-title {
					font-size: 0.15rem;
					color: #12121a;
					line-height: 0.21rem;
				}
				&-summary {
					font-size: 0.12rem;
					margin-top: 0.04rem;
					line-height: 0.16rem;
					color: #a5a5a5;
				}
				&-time {
					position: absolute;
					bottom: 0;
					color: #4a4a4a;
					font-size: 0.11rem;
					line-height: 0.15rem;
				}
			}
		}
		&-image {
			float: right;
			width: 1.11rem;
			height: 0.84rem;
			border-radius: 0.04rem 0.06rem 0.06rem 0.06rem;
			overflow: hidden;
		}
	}
}
</style>
